<div class="generic-table-container">
  @if (!loading && isPaginated) {
    <div class="table-toolbar">
      <span class="toolbar-label">Page {{ page }} of {{ totalPages }}</span>
      <div class="toolbar-actions">
        <button mat-stroked-button type="button" (click)="previousPage()" [disabled]="page === 1">
          <mat-icon>chevron_left</mat-icon>
          <span>Previous</span>
        </button>
        @if (settingsContext.gridSettings.allowPageSizeSelection) {
          <label class="page-size">
          <span>Show</span>
          <select [value]="pageSize" (change)="onPageSizeChange(+$any($event.target).value)">
            @for (size of pageSizeOptions; track size) {
              <option [value]="size">{{ size }}</option>
            }
          </select>
        </label>
        }
        <button mat-stroked-button type="button" (click)="nextPage()" [disabled]="page === totalPages">
          <span>Next</span>
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  }

  <div class="table-wrap">
    <table mat-table [dataSource]="paginatedData" class="generic-table">
      @for (column of visibleColumns; track trackColumn($index, column)) {
        <ng-container [matColumnDef]="column.id">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.width]="column.width || null"
            [class.sortable]="column.sortable && settingsContext.gridSettings.enableSorting"
            (click)="handleSort(column)"
          >
            <div class="header-content" [class]="resolveAlignClass(column)">
              <span>{{ column.label }}</span>
              @if (
                settingsContext.gridSettings.enableSorting &&
                column.sortable &&
                sortColumn === column.id
              ) {
                <mat-icon class="sort-icon">{{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
              }
            </div>
          </th>
          <td mat-cell *matCellDef="let row" [style.width]="column.width || null">
            <div class="cell-content" [class]="resolveAlignClass(column)" [class.contact-cell]="column.id === 'contact'">
              @if (isMultiLineCell(row, column)) {
                <div class="cell-stack">
                  @for (line of getCellLines(row, column); track $index) {
                    <div class="cell-line">
                      <span class="cell-text">{{ line }}</span>
                      @if (column.copyable && line !== '-') {
                        <button
                          mat-icon-button
                          type="button"
                          class="copy-btn"
                          aria-label="Copy value"
                          (click)="copyValue(line, $event)"
                        >
                          <mat-icon>content_copy</mat-icon>
                        </button>
                      }
                    </div>
                  }
                </div>
                            } @else {
                <!-- UPGRADED: Support multiple badges in a flex container -->
                @if (getBadgeValues(row, column).length > 0) {
                  <div style="display: flex; gap: var(--space-1); flex-wrap: wrap;">
                    @for (badgeValue of getBadgeValues(row, column); track $index) {
                      <span
                        class="table-badge"
                        [class]="'table-badge variant-' + (badgeValue.variant || 'default')"
                        [ngStyle]="badgeValue.style || null"
                      >
                        {{ badgeValue.text }}
                      </span>
                    }
                  </div>
                } @else {
                  <span class="cell-text">{{ getCellValue(row, column) ?? '-' }}</span>
                  @if (column.copyable) {
                    <button
                      mat-icon-button
                      type="button"
                      class="copy-btn"
                      aria-label="Copy value"
                      (click)="copyValue(getCellValue(row, column), $event)"
                    >
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  }
                }
              }
            </div>
          </td>
        </ng-container>
      }

      @if (actions.length > 0) {
        <ng-container matColumnDef="__actions">
          <th mat-header-cell *matHeaderCellDef class="action-col">Actions</th>
          <td mat-cell *matCellDef="let row" class="action-col">
            <button mat-icon-button type="button" [matMenuTriggerFor]="actionMenu" aria-label="Open row actions">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #actionMenu="matMenu">
              @for (action of actions; track $index) {
                @if (!isActionHidden(action, row)) {
                  <button mat-menu-item type="button" [disabled]="isActionDisabled(action, row)" (click)="action.onClick(row)">
                    @if (action.icon) {
                      <mat-icon>{{ action.icon }}</mat-icon>
                    }
                    <span>{{ getActionLabel(action, row) }}</span>
                  </button>
                }
              }
            </mat-menu>
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  @if (loading) {
    <div class="table-state">
      <mat-icon>hourglass_empty</mat-icon>
      <span>Loading data...</span>
    </div>
  } @else if (paginatedData.length === 0) {
    <div class="table-state">
      <mat-icon>inbox</mat-icon>
      <span>{{ emptyMessage }}</span>
    </div>
  }

  @if (!loading && isPaginated && totalPages > 1) {
    <div class="table-toolbar footer">
      <span class="toolbar-label">Showing {{ ((page - 1) * pageSize) + 1 }} - {{ Math.min(page * pageSize, sortedData.length) }} of {{ sortedData.length }}</span>
      <div class="toolbar-actions">
        <button mat-stroked-button type="button" (click)="previousPage()" [disabled]="page === 1">
          <mat-icon>chevron_left</mat-icon>
          <span>Previous</span>
        </button>
        <button mat-stroked-button type="button" (click)="nextPage()" [disabled]="page === totalPages">
          <span>Next</span>
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  }
</div>
